import {Controller} from "stimulus";

export default class extends Controller {
  visit(event) {
    if (event.target.closest("a") || event.target.closest("button")) return;

    var url = this.element.dataset.clickableRowUrl;
    if (url) window.location.href = url;
  }
}
